import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import ReactModal from "react-modal";
import * as IoIcons from "react-icons/io";
import CreaGestion from "../modals/CreaGestion";
import { ObtenerGestionPorSolicitud } from "../Services/Rest";
import * as XLSX from "xlsx";

const Consolidado = (props) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [gestiones, setGestiones] = useState([]);
  const [descripcionCompleta, setDescripcionCompleta] = useState("");
  const [showModal, setShowModal] = useState(false);

  const {
    id,
    correoCreador,
    fechaCreacion,
    regional,
    descripcion,
    estado,
    nombreCliente,
    usuarioAsignado,
    userIdAsignacion,
    clasificacionComercial,
    modalidad,
    modular,
    nombreCapacitacion,
    duracion,
    numeroParticipantes,
    entregables,
    otrosRequerimientos,
    campoObservacion,
    adjunto,
    detalleEstado,
    nombreUsuario,
  } = props;

  useEffect(() => {
    axios({
      auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
      method: "get",
      url: `${ObtenerGestionPorSolicitud}${id}&Origen=Educacion`,
    })
      .then((res) => setGestiones(res.data))
      .catch((err) => console.log(err));
  }, [id]);

  const exportToExcel = () => {
    const fileName = "Gestiones.xlsx";
    const worksheet = XLSX.utils.json_to_sheet(gestiones);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, fileName);
  };

  const formFields = [
    { label: "Correo del Gestor", value: regional },
    { label: "Descripción", value: descripcion, isTextArea: true },
    { label: "Estado", value: estado },
    {
      label: "Fecha",
      value: new Date(fechaCreacion).toLocaleDateString("es-CO"),
    },
    { label: "Nombre Cliente", value: nombreCliente },
    { label: "Nombre Del Comercial", value: nombreUsuario },
    { label: "Regional", value: userIdAsignacion },
    { label: "Clasificación Comercial", value: clasificacionComercial },
    { label: "Modalidad", value: modalidad },
    { label: "Modular", value: modular },
    { label: "Nombre Capacitación", value: nombreCapacitacion },
    { label: "Duración", value: duracion },
    { label: "Numero Participantes", value: numeroParticipantes },
    { label: "Entregables", value: entregables, isTextArea: true },
    {
      label: "Otros Requerimientos",
      value: otrosRequerimientos,
      isTextArea: true,
    },
    { label: "Campo Observación", value: campoObservacion, isTextArea: true },
  ];

  const handleShow = (descripcion) => {
    setDescripcionCompleta(descripcion);
    setShowModal(true);
  };

  const handleClose = () => {
    setDescripcionCompleta("");
    setShowModal(false);
  };
  const closeModal = () => setIsOpen(false);

  return (
    <Fragment>
      <button className="btn btn-secondary" onClick={() => setIsOpen(true)}>
        <IoIcons.IoIosSearch />
      </button>

      <ReactModal isOpen={modalIsOpen} onRequestClose={() => setIsOpen(false)}>
        <div className="container">
          {/* Información de la solicitud */}
          <br></br> <br></br>
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Información de la solicitud
              </h6>
            </div>
            <div className="card-body">
              <form className="user">
                <div className="container">
                  <div className="row">
                    {formFields.map((field, i) => (
                      <div
                        key={i}
                        className={`mb-3 ${
                          field.fullWidth ? "col-12" : "col-md-6"
                        }`}
                      >
                        <label className="form-label text-primary fw-bold">
                          {field.label}
                        </label>
                        {field.isTextArea ? (
                          <textarea
                            className="form-control"
                            value={field.value}
                            disabled
                            rows={3}
                          />
                        ) : (
                          <input
                            type="text"
                            className="form-control"
                            value={field.value}
                            disabled
                          />
                        )}
                      </div>
                    ))}
                  </div>

                  {adjunto != "" && (
                    <div className="row mt-3">
                      <div className="col-12 text-center">
                        <a
                          href={adjunto}
                          className="btn btn-outline-primary"
                          download
                        >
                          Descargar Adjunto
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </form>
            </div>
            <center>
              <button className="btn btn-secondary" onClick={closeModal}>
                Volver
              </button>
            </center>
            <br></br>
          </div>
          <br></br>
          <hr />
          {/* Tabla de gestiones */}
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Información Gestiones
              </h6>
            </div>
            <div className="card-body">
              <button className="btn btn-success mb-3" onClick={exportToExcel}>
                Exportar a Excel
              </button>
              <div className="table-responsive">
                <table className="table table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>Fecha Creación</th>
                      <th>Descripción</th>

                      <th>Adjunto</th>
                      <th>Usuario</th>
                      <th>Estado</th>
                      <th>Detalle Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {gestiones.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.fechaCreacion}</td>
                        <td
                          style={{
                            maxWidth: "250px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.descripcionGestion &&
                          typeof item.descripcionGestion == "string" &&
                          item.descripcionGestion.length > 100 ? (
                            <>
                              {item.descripcionGestion.slice(0, 100)}
                              <br></br>
                              <button
                                onClick={() =>
                                  handleShow(item.descripcionGestion)
                                }
                                className="btn btn-link btn-sm ms-1 p-0"
                                style={{ fontSize: "0.8rem" }}
                              >
                                Ver más
                              </button>
                            </>
                          ) : (
                            item.descripcionGestion || "Sin descripción"
                          )}
                        </td>

                        <td>
                          {item.adjunto == "" ? (
                            "No adjunto Archivo"
                          ) : (
                            <a
                              href={
                                "https://storagecompartidoicontec.blob.core.windows.net/file-educacion-gestiones/" +
                                item.adjunto
                              }
                              className="btn btn-outline-primary"
                              download
                            >
                              Descargar Adjunto
                            </a>
                          )}
                        </td>
                        <td>{item.usuarioId}</td>
                        <td>{item.estado}</td>
                        <td>{detalleEstado}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <CreaGestion id={id} correoCreador={correoCreador} />
            </div>
          </div>
        </div>

        {/* Modal para ver descripción completa */}
        <ReactModal
          isOpen={showModal}
          onRequestClose={handleClose}
          style={{
            content: {
              maxWidth: "600px",
              margin: "auto",
              padding: "40px",
            },
          }}
        >
          <br></br>
          <h5 className="text-primary mb-3">Descripción completa</h5>
          <div
            style={{
              maxHeight: "300px",
              overflowY: "auto",
              whiteSpace: "pre-wrap",
            }}
          >
            <textarea
              className="form-control"
              value={descripcionCompleta}
              readOnly
              rows={26}
              style={{
                resize: "none",
                backgroundColor: "#f9f9f9",
                border: "1px solid #ccc",
                padding: "10px",
                fontSize: "14px",
                borderRadius: "8px",
                width: "100%",
              }}
            />
          </div>
          <div className="text-end mt-3">
            <button className="btn btn-secondary" onClick={handleClose}>
              Cerrar
            </button>
          </div>
        </ReactModal>
      </ReactModal>
    </Fragment>
  );
};

export default Consolidado;
